import React from 'react';
import { Box, TextField, Typography, Alert } from '@mui/material';

import { LocationInputAction } from '../../../types';

interface LocationInputActionEditorProps {
  action: LocationInputAction;
  onChange: (action: LocationInputAction) => void;
}

const LocationInputActionEditor: React.FC<LocationInputActionEditorProps> = ({
  action,
  onChange,
}) => {
  const handleChange = (field: keyof LocationInputAction['data'], value: string) => {
    onChange({
      ...action,
      data: {
        ...action.data,
        [field]: value,
      },
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Key"
        value={action.data.key}
        onChange={(e) => handleChange('key', e.target.value)}
        fullWidth
        helperText="The key used to store the selected location in context"
        placeholder="eventLocation"
      />

      <Alert severity="info">
        <Typography variant="body2" gutterBottom>
          <strong>Location Input:</strong>
        </Typography>
        <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 0 }}>
          <li>Users will be prompted to enter a location using an autocomplete address field</li>
          <li>
            The selected location will be saved to context as <code>{action.data.key}</code>
          </li>
          <li>
            You can reference this location in subsequent actions using{' '}
            <code>{`{{${action.data.key}}}`}</code>
          </li>
        </Typography>
      </Alert>

      <Alert severity="success">
        <Typography variant="body2">
          <strong>Example:</strong> Setting Key to &quot;eventLocation&quot; will allow you to use{' '}
          <code>{'{{eventLocation}}'}</code> in later messages to reference the entered location.
        </Typography>
      </Alert>
    </Box>
  );
};

export default LocationInputActionEditor;
